/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';
import { Stack } from '@mui/material';
import { IAlertProps } from '../../interface/IAlertProps';
import { getDefaultAlertProps } from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { WINDOW_V } from '../../constant/constants';

export const SignInEmptyDiv2 = () => {
  const [windowState, setWindowState] = useState(WINDOW_V);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );

  return (
    <Stack
      height="100%"
      alignItems="center"
      justifyContent="center"
      spacing={1}
    >
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <iframe
        id="audioIFrame"
        style={{
          width: '100%',
          height:
            windowState === WINDOW_V
              ? (windowWidth * 9) / 16
              : (windowWidth * 9) / 16 / 1.5,
          border: 'none',
        }}
        src="https://kinescope.io/embed/2WFmbHsNz1W72DL9DGz2ps"
        allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write; screen-wake-lock;"
        // eslint-disable-next-line react/style-prop-object
        // https://kinescope.io/oRRugLnzoqxhj8tjXPrAgv
      />
      <iframe
        id="audioIFrame"
        style={{
          width: '100%',
          height:
            windowState === WINDOW_V
              ? (windowWidth * 9) / 16
              : (windowWidth * 9) / 16 / 1.5,
          border: 'none',
        }}
        src="https://kinescope.io/embed/oRRugLnzoqxhj8tjXPrAgv"
        allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write; screen-wake-lock;"
        // eslint-disable-next-line react/style-prop-object
        // https://kinescope.io/oRRugLnzoqxhj8tjXPrAgv
      />
    </Stack>
  );
};
